import { Grid } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
import { IGridQuestionGroup } from '../../../types';
import GridQuestionHeader from './GridQuestionHeader';
import GridQuestionRow from './GridQuestionRow';

interface IProps {
  questionGroup: IGridQuestionGroup;
}

const GridQuestionGroup = ({ questionGroup }: IProps) => {
  return (
    <StyledGrid
      container
      direction="row"
      justify="flex-start"
      alignItems="center"
    >
      <QuestionGridBody>
        <GridQuestionHeader
          alternatives={questionGroup.gridAlternatives || []}
        />
        {questionGroup.questions.map((question) => {
          return (
            <GridQuestionRow
              key={`radioGroup-${question.title}`}
              question={question}
              alternatives={questionGroup.gridAlternatives}
            />
          );
        })}
      </QuestionGridBody>
    </StyledGrid>
  );
};

const StyledGrid = styled(Grid)`
  margin-bottom: 30px;
`;

const QuestionGridBody = styled.div`
  width: 100%;
  > :nth-child(even) {
    background-color: #e4e4e4;
  }
  > :nth-child(odd) {
    background-color: #ffffff;
  }
`;

export default GridQuestionGroup;
